<div class="buttons">
    <div class="button-wrapper"><button class="btn-primary btn-block btn-large" (click)="reset()"><i class="icon">check</i></button></div>
    <div class="button-wrapper"><button class="btn-danger btn-block btn-large" (click)="close()"><i class="icon">delete</i></button></div>
</div>
